import { src } from '@data'
import { usePatient } from '@hook'
import { useAppDispatch } from '@store/hooks'
import { AuditTrail, Badge, SideDrawer } from '@ui'
import InformationList from '@ui/InformationList'
import { Avatar, Box, Text } from 'grommet'
import { useState } from 'react'
import { getEmail } from '../../Staff/modals/DropContent'

const options = ['details', 'audit trail']

type Props = {
  onClose: () => void
  id?: string
}

export function ViewPatientModal({ id, onClose }: Props) {
  const dispatch = useAppDispatch()
  const [tab, setTab] = useState('details')
  const { singlePatient, singleIncluded } = usePatient({ id })

  const personalDetails = {
    Address: '-',
    'Date Of Birth': singlePatient && singlePatient?.attributes?.date_of_birth,
    'Email Address': singlePatient && getEmail(singleIncluded || [], singlePatient?.relationships?.user?.data?.id),
    'Full Name': singlePatient
      ? `${singlePatient?.attributes?.first_name} ${singlePatient?.attributes?.last_name}`
      : '',
    'Phone Number': (singlePatient && singlePatient?.attributes?.phone_number) || '',
    gender: singlePatient && singlePatient?.attributes?.gender
  }

  const emergencyContactDetails = {
    Address: '-',
    'Email Address': '-',
    'Full Name': singlePatient
      ? `${singlePatient?.attributes?.first_name} ${singlePatient?.attributes?.last_name}`
      : '',
    'Phone Number': '-',
    Relationship: '-'
  }

  return (
    <SideDrawer
      header={
        <>
          <Box align="center" direction="row" gap="medium" pad="medium">
            <Avatar size="70px" src={src} />
            <Box direction="column">
              <Text margin={{ bottom: 'small' }} size="24px" weight="bold">
                {singlePatient ? singlePatient?.attributes?.first_name : ''}{' '}
                {singlePatient ? singlePatient?.attributes?.last_name : ''}
              </Text>
              <Box width="90px">
                <Badge label="In-patient" onClick={() => {}} />
              </Box>
            </Box>
          </Box>
        </>
      }
      onClose={onClose}
      // options={options}
      // setTab={setTab}
      title="Patient Details"
    >
      {tab === 'details' && (
        <>
          <InformationList data={personalDetails} title="Personal Details" />
          <InformationList data={emergencyContactDetails} title="Emergency Contact" />
        </>
      )}
      {tab === 'audit trail' && <AuditTrail />}
    </SideDrawer>
  )
}

export default ViewPatientModal
